<script>

import { Overlay } from '../../'

export default {
    name: 'DeMarker',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'DeMarker Indicator - Identifies price reversal points',
                preset: {
                    name: 'DeMarker $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#ff5722'
                    }
                }
            }
        },
        use_for() { return ['DeMarker'] },
        calc() {
            return {
                props: {
                    length: { def: 14, text: 'Length' }
                },
                conf: { renderer: 'Splines' },
                update: `
                    let up = ts(Math.max(0, high[0] - high[1]))
                    let down = ts(Math.max(0, low[1] - low[0]))
                    let top = sum(up, length)[0], bottom = sum(down, length)[0]
                    return top + bottom ? top / (top + bottom) : 0
                `
            }
        }
    }
}
</script>
